module.exports = __webpack_public_path__ + "img/1536702145.d7252ab0.jpg";